export const VideoViewer = ({
  mediaURL,
  isMediaOpen,
}: { mediaURL?: string; isMediaOpen: boolean }) => {
  if (!isMediaOpen || !mediaURL) return null;

  return (
    // biome-ignore lint/a11y/useMediaCaption: <explanation>
    // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
    <video
      src={mediaURL}
      autoPlay
      playsInline
      width="100%"
      height="100%"
      onClick={(e: React.MouseEvent<HTMLVideoElement>) => e.stopPropagation()}
      loop
      controls
      className="object-contain absolute inset-0 size-full"
    />
  );
};
